import {axios} from "../services/axios";
import { adminApi } from "../api";


export type AdsDTO = {
  title: string,
  owner: string,
  message: string,
  status: string,
};



/**
 * Faq List
 * @date 04/05/2023 - 13:21:19
 *
 * @async
 * @param {*} params
 * @returns {unknown}
 */
export const getList = async (params:any) => {
    return await axios.get(`${adminApi.adsList}`, { params });
  };

  /**
   * Add Faq
   * @date 04/05/2023 - 16:19:09
   *
   * @async
   * @param {FaqDTO} data
   * @returns {unknown}
   */
  export const addAds = async (data: AdsDTO) => {
    return axios.post(`${adminApi.adsAdd}`, data);
  };

  /**
   * Faq Edit
   * @date 04/05/2023 - 17:54:51
   *
   * @async
   * @param {string} id
   * @returns {Promise<any>}
   */
  export const getDetails = async (id: string): Promise<any> => {
    return axios.get(`${adminApi.adsDetails}/${id}`);
  };

  /**
   * Faq Edit
   * @date 04/05/2023 - 17:54:51
   *
   * @async
   * @param {string} id
   * @returns {Promise<any>}
   */
  export const edit = async (id: string,data: AdsDTO): Promise<any> => {
    return axios.patch(`${adminApi.adsEdit}/${id}`,data);
  };
 
  export const deleteAds = async (id: string): Promise<any> => {
    return axios.delete(`${adminApi.adsDelete}/${id}`);
  };